require('./brokerAlertsConfigPhone.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { formatText } = require('core/i18n').i18n;

// @commons
const { OKLink } = require('commonsComponents/OKLink');

//@utilities
const PersonalDataHelper = require('utilities/personalDataHelper');


const BrokerAlertsConfigPhone = (props) => {    
    const phoneNumber = PersonalDataHelper.getPhoneNumber(props.immProfileFields);
    const MY_PROFILE_LINK = '/myprofile/edit';
    return (
        <div className="broker-alerts-config-phone">
            <p className="broker-alerts-config-phone__label">{formatText('broker-alertsConfigYourPhoneIs')}</p>
            <p className="broker-alerts-config-phone__number-container">
                <span className="broker-alerts-config-phone__number">{phoneNumber}</span>
                <span className="broker-alerts-config-phone__update-number">
                    <OKLink id="lnkBrokerAlertsConfigPhoneUpdate" modifier="complementary" to={MY_PROFILE_LINK}>
                        {formatText('broker-alertsConfigUpdate')}
                    </OKLink>
                </span>
            </p>
            <p className="broker-alerts-config-phone__text1">{formatText('broker-alertsConfigPhoneKeepUpdated')}</p>
            <hr className="broker-alerts-config-phone__divider"/>
            <p className="broker-alerts-config-phone__text2">{formatText('broker-alertsConfigPhoneDisclaimer')}</p>
        </div>
    );
};

BrokerAlertsConfigPhone.propTypes = {
    immProfileFields: PropTypes.object.isRequired
}

module.exports = BrokerAlertsConfigPhone;
